import css from 'styled-jsx/css';

const styles = css.global`#seguro-auto-mao-na-roda {
    background: #FBFBFB;
    padding: 40px 0 16px;
}

#seguro-auto-mao-na-roda .ctn-home-24 {
    display: flex;
    flex-direction: column;
    gap: 56px;
}

#seguro-auto-mao-na-roda .mao-na-roda-titulos {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#seguro-auto-mao-na-roda .mao-na-roda-titulo {
    color: #222;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
}

#seguro-auto-mao-na-roda .mao-na-roda-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#seguro-auto-mao-na-roda .mao-na-roda-servicos {
    display: flex;
    flex-direction: column;
    gap: 32px;
    align-items: center;
}

#seguro-auto-mao-na-roda .mao-na-roda-servicos-lista {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
}

#seguro-auto-mao-na-roda .mao-na-roda-servico {
    display: flex;
    gap: 16px;
    align-items: center;
    width: 100%;
}

#seguro-auto-mao-na-roda .mao-na-roda-servico .mao-na-roda-servico-ic {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#seguro-auto-mao-na-roda .mao-na-roda-servico .mao-na-roda-servico-ic img {
    width: 40px;
    height: 40px;
}

#seguro-auto-mao-na-roda .mao-na-roda-servico-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
}

#seguro-auto-mao-na-roda .mao-na-roda-regulamento {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}

#seguro-auto-mao-na-roda .mao-na-roda-regulamento a {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
}

@media (min-width: 992px) {
    #seguro-auto-mao-na-roda {
        padding: 40px 0 27px;
    }
    
    #seguro-auto-mao-na-roda .ctn-home-24 {
        gap: 88px;
    }

    #seguro-auto-mao-na-roda .mao-na-roda-titulo {
        font-size: 56px;
        line-height: 120%;
    }
    
    #seguro-auto-mao-na-roda .mao-na-roda-texto {
        font-size: 24px;
        line-height: 36px;
    }

    #seguro-auto-mao-na-roda .mao-na-roda-servicos {
        flex-direction: row;
        gap: 96px;
    }
 
    #seguro-auto-mao-na-roda .mao-na-roda-servicos .img-mao-na-roda {
        width: 419px;
    }

    #seguro-auto-mao-na-roda .mao-na-roda-servicos-lista {
        gap: 40px;
    }

    #seguro-auto-mao-na-roda .mao-na-roda-servico-texto {
        font-size: 24px;
        line-height: 36px;
    }

    
}`;

export default styles;